<template>
  <div>
    <!-- <app-overlay-loader v-if="preloader" /> -->
    <div class="row">
      <div class="col-12 mb-primary">
        <!-- <div class="text-right mr-5" v-if="siteList == true">
                <button
                    type="button"
                    class="btn btn-primary btn-with-shadow"
                    @click="stiteList"
                >
                    {{ $t("site_list") }}
                </button>
            </div> -->
        <div class="text-right mr-5" v-if="siteAdd == true">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="addSite"
          >
            {{ $t("add_site") }}
          </button>
        </div>
      </div>
    </div>
    <div class="vertical-tab">
      <div class="row">
        <!-- <div class="col-2">
                <div class="card">
                    <div class="card-body">
                        <h4>Site List</h4>
                        <ul v-for="(site, index) in sites" :key="index">
                            <a href="#" @click="stiteList(site.id)"><li>{{ site.title }}</li></a>
                        </ul>
                    </div>
                </div>
            </div> -->
        <div class="col-md-3 pr-md-3 tab-menu">
          <div class="card card-with-shadow border-0">
            <div class="header-icon">
              <div class="icon-position d-flex justify-content-center">
                <div
                  class="
                    tab-icon
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                >
                  <app-icon name="link" />
                </div>
              </div>
            </div>
            <div class="px-primary py-primary">
              <div
                class="nav flex-column nav-pills"
                role="tablist"
                aria-orientation="vertical"
              >
                <app-overlay-loader v-if="preloader" />
                <p class="text-center" v-if="sites.length == 0">
                  This job no site
                </p>
                <a
                  style="
                    border-bottom: 0px;
                    border-color: transparent;
                    cursor: pointer;
                  "
                  v-for="(site, index) in sites"
                  :key="index"
                  class="
                    text-capitalize
                    tab-item-link
                    d-flex
                    justify-content-between
                    my-2 my-sm-3
                  "
                  data-toggle="pill"
                  @click.prevent="stiteList(site.id)"
                >
                  <span>{{ site.title }}</span>
                  <span class="active-icon"
                    ><app-icon name="chevron-right"
                  /></span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-9 pl-md-3 pt-md-0 pt-sm-4 pt-4">
          <site-create v-if="isSiteCreate" :getJob="getJob" :siteid="id" />

          <site-list
            v-if="isSiteList"
            :id="siteId"
            :getJob="getJob"
            :siteid="id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMPANY_JOB_SHOW } from "../../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../../Helpers/AxiosHelper.js";
// import CopyButton from "../../../Demo/UI/CopyButton.vue";

export default {
  name: "Site",
  //   components: { CopyButton },
  data() {
    return {
      preloader: true,
      isSiteCreate: false,
      isSiteList: true,
      siteAdd: true,
      siteList: false,
      siteId: 0,
      sites: {},
      id: "",
    };
  },
  methods: {
    stiteList(id) {
      this.siteId = id;
      this.isSiteCreate = false;
      this.isSiteList = true;
      this.siteAdd = true;
      // this.siteList = false;
    },
    addSite() {
      this.isSiteCreate = true;
      this.isSiteList = false;
      this.siteAdd = false;
      // this.siteList = true;
    },
    getJob(id) {
      axiosGet(COMPANY_JOB_SHOW + "/" + id)
        .then((res) => {
          this.job = res.data;
          this.sites = this.job.sites;
          this.preloader = true;
          if (this.sites.length > 0) {
            this.siteId = 1;
          }
        })
        .catch((error) => {
          
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
  mounted() {
    let myLocation = location.href;
    let split = myLocation.split("/");
    let nsplit = split[6].split("?");
    this.id = nsplit[0];
    this.getJob(nsplit[0]);
    this.sitesreload = true;
  },
  watch: {
    // whenever question changes, this function will run
    sites: function (newsites, oldsites) {
      // 
      // this.getJob(id);
    },
  },
};
</script>
